import React from 'react';
import FromServer from '../projects/FromServer';
import { Divider, Grid, Checkbox, Avatar, Button } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import LocalStorage from '../../providers/LocalStorage';
import DocumenteList from '../../commons/DocumenteList';
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import CustomAppBar from '../../commons/AppBar';
import wordIcon from '../../Pics/word_icon.png'
import pdfIcon from '../../Pics/pdf.png'
import NewUserDrepturi from '../../commons/dialogs/NewUserDrepturi';
import ProgramLucru from '../../commons/dialogs/ProgramLucru';
import AlertNew from '../../commons/dialogs/AlertNew';
import ProgramCompanie from './ProgramCompanie';
// import ProgramCompanie from './ProgramCompanie';


import { ReactComponent as Chart } from '../../Pics/iconsManagementUtilizatori/Chart.svg';
import { ReactComponent as Trash } from '../../Pics/iconsManagementUtilizatori/Trash.svg';
import { ReactComponent as Edit } from '../../Pics/iconsManagementUtilizatori/Edit.svg';




export default class ManagementUtilizatori extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listUsersInterni: [],
            listUsersExterni: [],
            listDepartamente: [],
            isOpenNewUser: false,
            angajatInfo: {
                adresa: "",
                cnp: "",
                cost_minut: '',
                email: "",
                firma: '',
                functie: "",
                id: 0,
                id_departament: 0,
                id_user: 0,
                nume: "",
                nume_departament: "",
                oras: "",
                poza: "",
                salariu: '',
                sef_departament: '',
                telefon: "",
            },
            isFirmaExterna: false,
            toUpdate: false,
            userSelectat: '0',
            verifyEmail: '',
            parola: '',
            repetParola: '',
            vParola: '',
            isOpenProgram: false,
            societate: {},
            dAccess: [],
            idDepartament: 0,
            openDeleteUser: false,
            openProgramCompanie: false,
            programSelectat: -1,
            programCompanie: [],
            alertView: false,
            openAlertUseri: false

        }
    }

    //'Upload/DocTask'

    // adresaMedia/Proiecte/Docs

    // adresaMedia/Taskuri/Docs



    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()
    componentDidMount() {
        this.access()
        this.fromServer()
        this.getWindowDimentions()

        this.getProgramCompanie()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.IsAdmin === 1 ? false : true })
        }


    }


    getProgramCompanie = async () => {

        let getProgram = await this.ws.customSelect('select * from program_lucru where isnull(este_template,0)=1 and isnull(sters,0)!=1', {
            p1: 1
        })

        if (getProgram.Succes) {

            let programCompanie = [...getProgram.Content]

            for (let i = 0, n = programCompanie.length; i < n; i++) {

                programCompanie[i].lu_start = this.u.transformTimeFromSql(programCompanie[i].lu_start)
                programCompanie[i].lu_end = this.u.transformTimeFromSql(programCompanie[i].lu_end)
                programCompanie[i].ma_start = this.u.transformTimeFromSql(programCompanie[i].ma_start)
                programCompanie[i].ma_end = this.u.transformTimeFromSql(programCompanie[i].ma_end)
                programCompanie[i].mi_start = this.u.transformTimeFromSql(programCompanie[i].mi_start)
                programCompanie[i].mi_end = this.u.transformTimeFromSql(programCompanie[i].mi_end)
                programCompanie[i].jo_start = this.u.transformTimeFromSql(programCompanie[i].jo_start)
                programCompanie[i].jo_end = this.u.transformTimeFromSql(programCompanie[i].jo_end)
                programCompanie[i].vi_start = this.u.transformTimeFromSql(programCompanie[i].vi_start)
                programCompanie[i].vi_end = this.u.transformTimeFromSql(programCompanie[i].vi_end)
                programCompanie[i].sa_start = this.u.transformTimeFromSql(programCompanie[i].sa_start)
                programCompanie[i].sa_end = this.u.transformTimeFromSql(programCompanie[i].sa_end)
                programCompanie[i].du_start = this.u.transformTimeFromSql(programCompanie[i].du_start)
                programCompanie[i].du_end = this.u.transformTimeFromSql(programCompanie[i].du_end)


                programCompanie[i].lu_pauza_start = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_start)
                programCompanie[i].lu_pauza_end = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_end)
                programCompanie[i].ma_pauza_start = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_start)
                programCompanie[i].ma_pauza_end = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_end)
                programCompanie[i].mi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_start)
                programCompanie[i].mi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_end)
                programCompanie[i].jo_pauza_start = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_start)
                programCompanie[i].jo_pauza_end = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_end)
                programCompanie[i].vi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_start)
                programCompanie[i].vi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_end)
                programCompanie[i].sa_pauza_start = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_start)
                programCompanie[i].sa_pauza_end = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_end)
                programCompanie[i].du_pauza_start = this.u.transformTimeFromSql(programCompanie[i].du_pauza_start)
                programCompanie[i].du_pauza_end = this.u.transformTimeFromSql(programCompanie[i].du_pauza_end)
            }


            console.log('programCompanie :>> ', programCompanie);
            this.setState({
                programCompanie: programCompanie,
                programSelectat: programCompanie.length > 0 ? programCompanie[0] : null

            })
        }
    }

    changeProgramAll = (ev) => {

        let val = ev.target.value

        let programe = [...this.state.programCompanie]

        let idx = programe.findIndex(i => Number(i.id) === Number(val))

        console.log('idx :>> ', idx);
        if (idx !== -1) {

            console.log('programe :>> ', programe[idx]);

            let angajatInfo = { ...this.state.angajatInfo }

            angajatInfo.lu_start = programe[idx].lu_start
            angajatInfo.lu_end = programe[idx].lu_end
            angajatInfo.ma_start = programe[idx].ma_start
            angajatInfo.ma_end = programe[idx].ma_end
            angajatInfo.mi_start = programe[idx].mi_start
            angajatInfo.mi_end = programe[idx].mi_end
            angajatInfo.jo_start = programe[idx].jo_start
            angajatInfo.jo_end = programe[idx].jo_end
            angajatInfo.vi_start = programe[idx].vi_start
            angajatInfo.vi_end = programe[idx].vi_end
            angajatInfo.sa_start = programe[idx].sa_start
            angajatInfo.sa_end = programe[idx].sa_end
            angajatInfo.du_start = programe[idx].du_start
            angajatInfo.du_end = programe[idx].du_end
            angajatInfo.id_template = programe[idx].id



            this.setState({
                angajatInfo: angajatInfo,
                programSelectat: val
            }, () => {
                this.saveProgram()
            })
        }

    }


    fromServer = async (a = null) => {
        let fs = new FromServer();

        let ws = new Ws()

        // ct(`select d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
        //                                      a.nume, a.poza, a.cost_minut, u.email, u.firma, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
        //                                      left join angajati a on u.id = a.id_user 
        //                                      left join angajati_departamente ad on ad.id_angajat = a.id
        //                                      left join departamente dep on dep.id = ad.id_departament
        //                                      where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {




        // let de = await ws.customSelect('select * from angajati_departamente', {
        //     p1: 1
        // })

        // // console.log('de :>> ', de);


        let getSocietate = await ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        console.log('getSocietate :>> ', getSocietate);


        if (getSocietate.Succes) {

            // let getUserLogator = await ws.customSelect(`select * from pm_logator.[dbo].useri where nume = @p1`, { p1: 'Cristi' })

            // let getUseri = await ws.customSelect('select * from useri where 1 = 1 ', { p1: 25 })

            // console.log('getUserLogator :>> ', getUserLogator);

            // console.log('getUseri :>> ', getUseri);

            let usersTest = await this.ws.customSelect('select * from useri where id = @p1', {
                p1: 2
            })

            let angajatiTest = await this.ws.customSelect('select * from angajati where id = @p1', { p1: 2 })

            let angajatiDepartamenteTest = await this.ws.customSelect('select * from angajati_departamente where id_angajat = @p1', { p1: 2 })

            let angajatiLogator = await this.ws.customSelect('select * from pm_logator.[dbo].useri where id_user_bazadate_proprie = 2 and id_societate_client = @p2', {
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 0
            })

            console.log('usersTest :>> ', usersTest);
            console.log('angajatiTest :>> ', angajatiTest);
            console.log('angajatiDepartamenteTest :>> ', angajatiDepartamenteTest);
            console.log('angajatiLogator :>> ', angajatiLogator);

            let _users = ws.customSelect(`select
            a.id , dep.id as id_departament, u.id as id_user,
            a.permis_conducere, u.token,
            l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
            ad.sef_departament,a.cnp,a.adresa,a.telefon,
            a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu,a.salariu_moneda, a.doc_fisa_postului,a.cv,a.nr_zile_concediu, u.access_financiar, u.email, u.firma,u.firma_externa, u.is_admin, dep.nume as nume_departament  from  useri u
            left join angajati a on u.id = a.id_user 
            left join angajati_departamente ad on ad.id_angajat = a.id
            left join departamente dep on dep.id = ad.id_departament
            left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
            where isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
            })

            let logator = await ws.customSelect(`select * from pm_logator.[dbo].useri `, { p1: 1 })

            console.log('logator :>> ', logator);

            // let angajati = await ws.customSelect('select * from angajati', {
            //     p1: 1
            // })

            // console.log('angajati :>> ', angajati);

            let departamente = ws.customSelect('select * from departamente where isnull(inactiv,0) != 1', {
                p1: 0
            })


            let programLucru = ws.customSelect('select * from program_lucru where 1 = @p1', {
                p1: 1
            })

            let _departementeAcces = ws.customSelect(`select d.*, a.id as id_departament_access, a.id_angajat from angajati_acces_departamente a left join departamente d  on
            d.id = a.id_departament where a.id_angajat = @p1 and isnull(a.sters,0) != 1`, { p1: this.state.angajatInfo.id })


            let [users, dep, p, dAccess] = await Promise.all([_users, departamente, programLucru, _departementeAcces])



            console.log('users :', users);
            console.log('dAccess :>> ', dAccess);


            if (users.Succes && dep.Succes && p.Succes) {

                let time = new Utils()

                let program = [...p.Content]

                let listUsers = [...users.Content]


                for (let i = 0, n = listUsers.length; i < n; i++) {

                    let idx = program.findIndex(p => p.id_angajat === listUsers[i].id)

                    listUsers[i].selectat = false
                    listUsers[i].lu_start = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_start) : '00:00'
                    listUsers[i].lu_end = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_end) : '18:00'
                    listUsers[i].ma_start = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_start) : '00:00'
                    listUsers[i].ma_end = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_end) : '18:00'
                    listUsers[i].mi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_start) : '00:00'
                    listUsers[i].mi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_end) : '18:00'
                    listUsers[i].jo_start = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_start) : '00:00'
                    listUsers[i].jo_end = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_end) : '18:00'
                    listUsers[i].vi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_start) : '00:00'
                    listUsers[i].vi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_end) : '18:00'
                    listUsers[i].sa_start = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_start) : '00:00'
                    listUsers[i].sa_end = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_end) : '18:00'
                    listUsers[i].du_start = idx !== -1 ? time.transformTimeFromSql(program[idx].du_start) : '00:00'
                    listUsers[i].du_end = idx !== -1 ? time.transformTimeFromSql(program[idx].du_end) : '18:00'
                    listUsers[i].id_template = idx !== -1 ? program[idx].id_template : 0
                }





                let usersInterni = listUsers.filter(u => u.firma_externa !== 1)

                let useriExterni = listUsers.filter(u => u.firma_externa === 1)


                if (a) {
                    let angajat = { ...this.state.angajatInfo }

                    let idx = listUsers.findIndex(i => i.id === a.id)

                    if (idx !== -1) {
                        let newAngajat = listUsers[idx]

                        this.setState({ angajatInfo: newAngajat })
                    }
                }





                console.log('useriExterni :>> ', useriExterni);


                this.setState({
                    listUsersInterni: usersInterni,
                    listUsersExterni: useriExterni,
                    listDepartamente: dep.Content,
                    societate: getSocietate.Content[0],
                    parola: '',
                    repetParola: '',
                    dAccess: dAccess.Content,

                })

            }


        }





    }



    saveProgram = async () => {

        let ws = new Ws();

        let verifyProgram = await ws.customSelect('select count(*) as c from program_lucru where id_angajat = @p1', {
            p1: this.state.angajatInfo.id
        })


        console.log('this.state.angajatInfo :>> ', this.state.angajatInfo);
        let objToInsert = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,
            id_angajat: this.state.angajatInfo.id,
            id_template: this.state.angajatInfo.id_template || 0,

        }

        let objToUpdate = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,
            id_template: this.state.angajatInfo.id_template || 0,

        }

        // console.log('objToInsert :', objToInsert);


        // console.log('verifyProgram :', verifyProgram);
        if (verifyProgram.Succes) {
            if (verifyProgram.Content[0].c === 0) {
                let insertProgram = await ws.insert('program_lucru', objToInsert)

                if (insertProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            } else {
                let updateProgram = await ws.update('program_lucru', objToUpdate, { id_angajat: this.state.angajatInfo.id })

                if (updateProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            }
        }
    }

    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    uploadDoc = async (id, idProiect) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/DocProiect', saveFile, idProiect);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.getDocumente()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }











    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }

    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }





    changeFirma = async (ev) => {
        let angajat = { ...this.state.angajatInfo }

        let checked = ev.target.checked

        if (ev.target.checked) {
            angajat.departament = ''

            let updateDepAccess = await this.ws.update('angajati_acces_departamente', { sters: 1 }, { id_angajat: angajat.id })

            if (updateDepAccess.Succes) {

                this.setState({
                    angajatInfo: angajat,
                    isFirmaExterna: checked
                })
            }


        } else {
            angajat.firma = ''
            this.setState({
                angajatInfo: angajat,
                isFirmaExterna: checked
            })
        }
    }

    selectUserIntern = async (u) => {

        console.log('u :>> ', u);

        let user = { ...u }

        let _departementeAcces = await this.ws.customSelect(`select d.*, a.id as id_departament_access, a.id_angajat from angajati_acces_departamente a left join departamente d  on
        d.id = a.id_departament where a.id_angajat = @p1 and isnull(a.sters,0) != 1`, { p1: u.id })

        if (_departementeAcces.Succes) {
            this.setState({
                angajatInfo: user,
                isOpenNewUser: true,
                toUpdate: true,
                isFirmaExterna: false,
                dAccess: _departementeAcces.Content,
                programSelectat: user.id_template || -1
            })
        }


    }

    selectUserExtern = (u) => {

        console.log('u :>> ', u);

        let user = { ...u }
        user.sef_departament = user.sef_departament === 1
        this.setState({
            angajatInfo: user,
            isOpenNewUser: true,
            toUpdate: true,
            isFirmaExterna: true,
        })
    }


    changeManager = (ev) => {
        let manager = { ...this.state.angajatInfo }

        manager["sef_departament"] = ev.target.checked ? 1 : 0


        if (manager['is_admin'] !== 1) {
            manager["access_financiar"] = manager["sef_departament"] === 0 ? 0 : manager["access_financiar"]
        }

        this.setState({ angajatInfo: manager })
    }

    changeAccessFinanciar = (ev) => {
        let accessFinanciar = { ...this.state.angajatInfo }

        accessFinanciar['access_financiar'] = ev.target.checked ? 1 : 0

        this.setState({ angajatInfo: accessFinanciar })
    }

    openNewUser = async () => {

        let ls = new LocalStorage().GetUserData()

        console.log('ls :>> ', ls);

        if (ls.InfoUser.NrMaxUtilizatori > (this.state.listUsersInterni.length + this.state.listUsersExterni)) {
            let ws = new Ws();


            let objToInsert = {
                nume: 'Nume Angajat',
                email: '',
                telefon: ''
            }

            let insertUser = await ws.insert('useri', objToInsert)




            if (insertUser.Succes) {

                // console.log('insertUser :', insertUser);
                let iAngajat = await ws.insert('angajati', { nume: objToInsert.nume, id_categorie: 1, data_angajarii: this.u.updateSqlNow(), id_user: insertUser.Content[0].id })





                if (iAngajat.Succes) {
                    // let iDep =await ws.insert('angajati_departamente',{id_angajat:iAngajat.Content[0].id,
                    //                                             id_departament:d.id})



                    let angajatInfo = {
                        adresa: "",
                        cnp: "",
                        cost_minut: '',
                        email: "",
                        firma: '',
                        firma_externa: 0,
                        functie: "",
                        id: iAngajat.Content[0].id,
                        id_departament: 0,
                        id_user: insertUser.Content[0].id,
                        nume: "",
                        nume_departament: "",
                        oras: "",
                        poza: "",
                        salariu: '',
                        sef_departament: '',
                        telefon: "",
                        access_financiar: '',
                        nr_zile_concediu: '',
                        salariu_moneda: 'lei',
                        permis_conducere: ''
                    }



                    this.setState({
                        angajatInfo: angajatInfo,
                        toUpdate: false,
                        isOpenNewUser: true,
                        isFirmaExterna: false,
                        dAccess: []
                    })



                }

            }


        } else {
            this.setState({ openAlertUseri: true })
        }






    }



    closeNewUser = async () => {
        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: this.state.angajatInfo.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: this.state.angajatInfo.id, id_departament: this.state.angajatInfo.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: this.state.angajatInfo.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: this.state.angajatInfo.id_user })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({
                isOpenNewUser: false,
                verifyEmail: '',
                vParola: ''
            })
        }

    }



    insertNewUser = async () => {
        let ws = new Ws();
        let u = new Utils();



        let _verifyEmail = ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri = ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati = ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id
        })

        // console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri, verifyEmailAngajati] = await Promise.all([_verifyEmail, _verifyEmailUseri, _verifyEmailAngajati])



        console.log('verifyEmail :>> ', verifyEmail);
        console.log('verifyEmailUseri :>> ', verifyEmailUseri);
        console.log('verifyEmailAngajati :>> ', verifyEmailAngajati);

        if (verifyEmail.Succes) {
            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0 && this.state.parola.length >= 5) {


                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    data_angajarii: u.updateSqlNow(),
                    salariu_moneda: this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu: this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere: this.state.angajatInfo.permis_conducere || '',

                }

                let objUser = {
                    token: u.randomData(32),
                    nume: this.state.angajatInfo.nume,
                    email: this.state.angajatInfo.email,
                    access_financiar: this.state.angajatInfo.access_financiar || ''

                }


                objUser['firma'] = this.state.angajatInfo.firma || ''
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0


                let getSocietate = await ws.customSelect('select * from setari where param_code = @p1', {
                    p1: 'soc_id'
                })

                if (getSocietate.Succes) {

                    let objNewUserLogator = {
                        token: objUser.token,
                        nume: this.state.angajatInfo.nume,
                        id_societate_client: getSocietate.Content[0].val,
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        id_user_bazadate_proprie: this.state.angajatInfo.id_user,
                    }

                    let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                    let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                    let iUserDrepturi = ws.insert('useri_drepturi', {
                        id_utilizator: this.state.angajatInfo.id_user,

                        profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                        acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        sterge_proiecte: 0

                    })

                    let insertD = ws.insert('angajati_departamente', {
                        id_angajat: this.state.angajatInfo.id,
                        id_departament: this.state.angajatInfo.id_departament,
                        sef_departament: this.state.angajatInfo.sef_departament || ''
                    })
                    let insertNewUser = ws.insert('pm_logator.[dbo].useri', objNewUserLogator)


                    let [a, u, d, n, iU] = await Promise.all([updateA, updateU, insertD, insertNewUser, iUserDrepturi])

                    console.log('iU :>> ', iU);

                    if (a.Succes && u.Succes && d.Succes && n.Succes) {



                        this.setState({
                            isOpenNewUser: false, verifyEmail: '',
                            vParola: ''
                        }, () => {

                            this.fromServer()
                        })
                    }


                    // console.log('insertNewUser :', insertNewUser);

                }






            } else {
                this.setState({
                    verifyEmail: this.state.parola.length >= 5 && (this.state.angajatInfo.email.length > 0 ? 'Emailul deja exista !' : 'Va rugam completati emailul!'),
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }

        }
    }





    updateAngajat = async () => {

        let ws = new Ws();
        let u = new Utils();

        // let verifyEmail = await ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
        //     p1: this.state.angajatInfo.email,
        //     p2: this.state.angajatInfo.id_user
        // })

        // console.log('verifyEmail :>> ', verifyEmail);

        // console.log('angajatInfo :>> ', this.state.angajatInfo);





        let _verifyEmail = ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri = ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati = ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id
        })

        console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri, verifyEmailAngajati] = await Promise.all([_verifyEmail, _verifyEmailUseri, _verifyEmailAngajati])




        console.log('getUserLogator :>> ', verifyEmail);
        if (verifyEmail.Succes) {

            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0) {

                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    salariu_moneda: this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu: this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere: this.state.angajatInfo.permis_conducere || '',


                }

                let objUser = {
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    access_financiar: this.state.angajatInfo.access_financiar || ''
                }

                let objNewUserLogator;

                if (this.state.parola.length > 3) {

                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        inactiv: 0

                    }
                } else {
                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        inactiv: 0
                        // parola: this.state.parola,
                        // parolac: this.state.parola,

                    }
                }


                console.log('objNewUserLogator :>> ', objNewUserLogator);




                objUser['firma'] = this.state.angajatInfo.firma || ''
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0


                console.log('this.state.angajatInfo :>> ', this.state.angajatInfo);
                console.log('objUser :>> ', objUser);

                let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })





                let selectDrepturi = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
                    p1: this.state.angajatInfo.id_user
                })

                let iUserDrepturi

                if (selectDrepturi.Succes) {
                    if (selectDrepturi.Content.length > 0) {
                        console.log('are Drepturi  :>> ', selectDrepturi.Content);

                        iUserDrepturi = ws.update('useri_drepturi', {

                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        }, { id_utilizator: this.state.angajatInfo.id_user, })
                    } else {
                        iUserDrepturi = ws.insert('useri_drepturi', {
                            id_utilizator: this.state.angajatInfo.id_user,
                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',


                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        })
                    }
                }





                // let iUserDrepturi = ws.insert('useri_drepturi', {

                //     id_utilizator:this.state.angajatInfo.id_user,

                //     profil_selectat:'Admin',

                //     acces_rapoarte: 1 ,
                //     acces_setari:  1 ,
                //     acces_utilizatori :  1 ,

                //     acces_extins_proiecte :  1 ,

                //     acces_evaluari :  1 ,
                //     can_edit_evaluari :  1 ,

                //     acces_monitorizare :  1 ,
                //     can_edit_monitorizare :  1 ,

                //     sterge_proiecte: 1

                // })




                let updateD = ws.update('angajati_departamente', {
                    id_departament: this.state.angajatInfo.id_departament || '',
                    sef_departament: this.state.angajatInfo.sef_departament || ''
                }, { id_angajat: this.state.angajatInfo.id })

                let updateNewUserL = ws.update('pm_logator.[dbo].useri', objNewUserLogator, { id_user_bazadate_proprie: this.state.angajatInfo.id_user, id_societate_client: Number(this.state.societate.val) })

                let [uA, uU, uD, iU, uL] = await Promise.all([updateA, updateU, updateD, iUserDrepturi, updateNewUserL])

                console.log('uA :>> ', uA);
                console.log('uU :>> ', uU);
                console.log('uD :>> ', uD);
                console.log('iU :>> ', iU);
                console.log('uL :>> ', uL);

                if (uA.Succes && uU.Succes && uD.Succes) {
                    this.setState({
                        isOpenNewUser: false, verifyEmail: '',
                        vParola: ''
                    }, () => {
                        this.fromServer()
                    })
                }
            } else {
                this.setState({
                    verifyEmail: this.state.angajatInfo.email.length > 0 ? 'Emailul deja exista !' : 'Va rugam completati emailul!',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }


        }
    }

    changeData = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        console.log('angajat :>> ', angajat);

        angajat[ev.target.name] = ev.target.value

        this.setState({
            angajatInfo: angajat,
            verifyEmail: ''
        })
    }


    deleteUser = async (us) => {

        let ws = new Ws()

        console.log('us :>> ', us);

        let updateA = ws.update('angajati', { inactiv: 1, statusul: 'Candidat' }, { id: us.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: us.id, id_departament: us.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: us.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { token: us.token })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({
                isOpenNewUser: false,
                openDeleteUser: false,
                verifyEmail: '',
                vParola: ''
            }, () => {

                this.fromServer()
            })
        }

    }


    openDeleteUser = (u) => {

        this.setState({
            angajatInfo: u,
            openDeleteUser: true
        })
    }


    changeProgram = nume => ev => {
        let oldState = { ...this.state.angajatInfo }

        oldState[nume] = ev.target.value

        console.log('ev.target.value :>> ', ev.target.value);
        console.log('nume :>> ', nume);

        this.setState({
            angajatInfo: oldState
        })
    }

    absent = (ev, zi) => {
        //    console.log('ev :', ev);

        //    console.log('zi :', zi);

        let oldState = { ...this.state.angajatInfo }

        if (oldState[zi] === '00:00') {
            oldState[zi] = '09:00'
        } else {
            oldState[zi] = '00:00'
        }
        this.setState({
            angajatInfo: oldState
        })
    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    changeidDepartament = async (ev) => {

        let val = ev.target.value

        console.log('val :>> ', val);

        let depAccess = [...this.state.dAccess]

        let idx = depAccess.findIndex(d => Number(d.id) === Number(val))

        if (idx === -1) {
            let insertDepAccess = await this.ws.insert('angajati_acces_departamente', {
                id_angajat: this.state.angajatInfo.id,
                id_departament: val
            })

            if (insertDepAccess.Succes) {
                this.fromServer()
            }
        }
    }


    deleteDep = async (d) => {

        console.log('d :>> ', d);

        let delDep = await this.ws.update('angajati_acces_departamente', { sters: 1 }, { id: d.id_departament_access })

        if (delDep.Succes) {
            this.fromServer()
        }



    }

    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} appBarButtons={this.buildAppBarButtons()} />

                {this.state.openProgramCompanie &&

                    <ProgramCompanie
                        open={this.state.openProgramCompanie}
                        dialogClose={() => {
                            this.setState({ openProgramCompanie: false }, () => {
                                this.fromServer()
                            })
                        }}
                        getData={this.fromServer}
                    />
                }


                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <AlertNew
                        open={this.state.alertView}
                        dialogClose={() => { this.setState({ alertView: false }) }}
                        title={this.dictionary.proiecte.alertView}
                        mesaj={this.dictionary.proiecte.alertViewMessage}
                        noButtonDisplay={1}
                        yesFunction={() => { this.props.history.replace('/') }}
                    />

                    <AlertNew
                        open={this.state.openAlertUseri}
                        dialogClose={() => { this.setState({ openAlertUseri: false }) }}
                        title={'Numarul maxim de utilizatori a fost atins !'}
                        mesaj={''}
                        noButtonDisplay={1}
                        yesFunction={() => { this.setState({ openAlertUseri: false }) }}
                    />

                    <AlertNew
                        open={this.state.openDeleteUser}
                        dialogClose={() => { this.setState({ openDeleteUser: false }) }}
                        title={'Doresti sa stergi definitiv utilizatorul ?'}
                        mesaj={'Utilizatorii odata stersi nu mai pot fi recuperati '}
                        yesFunction={() => { this.deleteUser(this.state.angajatInfo) }}
                        deleteP={true}
                    />

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'> {this.dictionary.managementUtilizatori.managementUtilizatori} </h1>
                            </Grid>

                            <Grid style={{ paddingTop: 80 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                <Button
                                    className='add-button-blue'
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { this.setState({ openProgramCompanie: true }) }}
                                >
                                    {this.dictionary.comune.adaugaProgramCompanie}
                                </Button>
                            </Grid>
                        </Grid>

                    </Grid>




                </Grid>

                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxWidth: 1000, margin: 'auto' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 18, fontWeight: 800, color: 'black', marginBottom: 40, display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ display: 'inline-flex' }}> {this.dictionary.managementUtilizatori.lucratoriInterni}  </span>

                            <Chart style={{ width: 24, height: 24 }} />
                            {/* <i className='material-icons'>device_hub</i> */}

                        </h4>
                    </Grid>


                    {this.state.listUsersInterni.map((u, idx) => {
                        return (
                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid style={{
                                    padding: 10,
                                    backgroundColor: '#FAFAFA',
                                    marginBottom: 20
                                }} container>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        {
                                            u.poza &&
                                            <div
                                                className='pm-angajati-picture'

                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + u.poza}')`, width: 36, height: 36, padding: 5 }}>

                                            </div>
                                        }
                                        {!u.poza &&

                                            <Avatar
                                                className='pm-angajati-picture'
                                                style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(u.id), padding: 5, cursor: 'pointer' }}>
                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                <span style={{ marginTop: '20%', display: 'block', fontSize: 14, fontWeight: 400 }}>{this.numeAvatar(u.nume)} </span>
                                            </Avatar>
                                            // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                        }
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{u.nume}</span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.functie}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{this.dictionary.managementUtilizatori.oras} </span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.oras}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{this.dictionary.managementUtilizatori.salariuBrut} </span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.salariu || 0} {u.salariu_moneda} </span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}> {this.dictionary.managementUtilizatori.costPeOra}</span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.cost_minut} {u.salariu_moneda} </span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Trash onClick={() => { this.openDeleteUser(u) }} style={{ width: 20, height: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} />
                                        <Edit onClick={() => { this.selectUserIntern(u) }} style={{ width: 20, height: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} />

                                        {/* <i onClick={() => { this.openDeleteUser(u) }} style={{ fontSize: 30, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>delete</i>
                                        <i onClick={() => { this.selectUserIntern(u) }} style={{ fontSize: 30, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>edit</i> */}

                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })}

                    <Grid style={{ textAlign: 'right' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button style={{ textTransform: 'none', display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.openNewUser}  >
                            {this.dictionary.managementUtilizatori.utilizatorNou}
                        </Button>

                    </Grid>
                </Grid>

                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxWidth: 1000, margin: 'auto', marginTop: 40 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 18, fontWeight: 800, color: 'black', marginBottom: 40 }}>
                            <span style={{ display: 'inline-flex' }}> {this.dictionary.managementUtilizatori.lucratoriExterni} </span>

                        </h4>
                    </Grid>


                    {this.state.listUsersExterni.map((u, idx) => {
                        return (
                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid style={{
                                    padding: 10,
                                    backgroundColor: '#FAFAFA',
                                    marginBottom: 20
                                }} container>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        {
                                            u.poza &&
                                            <div
                                                className='pm-angajati-picture'

                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + u.poza}')`, width: 36, height: 36, padding: 5 }}>

                                            </div>
                                        }
                                        {!u.poza &&

                                            <Avatar
                                                className='pm-angajati-picture'
                                                style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(u.id), padding: 5 }}>
                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                <span style={{ marginTop: '20%', display: 'block', fontSize: 14, fontWeight: 400 }}>{this.numeAvatar(u.nume)} </span>
                                            </Avatar>
                                            // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                        }
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{u.nume}</span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.functie}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{this.dictionary.managementUtilizatori.companie} </span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.firma}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}>{this.dictionary.managementUtilizatori.salariuBrut} </span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.salariu || 0} {u.salariu_moneda} </span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ fontWeight: 400, fontSize: 14 }}> {this.dictionary.managementUtilizatori.costPeOra} </span><br />
                                        <span style={{
                                            fontSize: 12,
                                            color: '#777777',
                                            fontWeight: 400
                                        }}>{u.cost_minut} {u.salariu_moneda}</span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Trash onClick={() => { this.openDeleteUser(u) }} style={{ width: 20, height: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} />
                                        <Edit onClick={() => { this.selectUserExtern(u) }} style={{ width: 20, height: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} />
                                        {/* <i onClick={() => { this.openDeleteUser(u) }} style={{ fontSize: 30, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>delete</i>
                                        <i onClick={() => { this.selectUserExtern(u) }} style={{ fontSize: 30, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>edit</i>
 */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })}

                    <Grid style={{ textAlign: 'right' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button style={{ textTransform: 'none', display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.openNewUser}   >
                            {this.dictionary.managementUtilizatori.utilizatorNou}
                        </Button>

                    </Grid>
                </Grid>



                {this.state.isOpenNewUser &&
                    <NewUserDrepturi
                        open={this.state.isOpenNewUser}
                        dialogClose={this.state.toUpdate ? () => { this.setState({ isOpenNewUser: false }) } : this.closeNewUser}
                        angajat={this.state.angajatInfo}
                        departamente={this.state.listDepartamente}
                        isFirmaExterna={this.state.isFirmaExterna}
                        changeFirma={this.changeFirma}
                        changeData={(ev) => { this.changeData(ev) }}
                        limba={this.dictionary}
                        vEmail={this.state.verifyEmail}
                        updateAngajat={this.state.toUpdate ? this.updateAngajat : this.insertNewUser}
                        parola={this.state.parola}
                        repetParola={this.state.repetParola}
                        parolaChange={(ev) => { this.setState({ parola: ev.target.value }) }}
                        repetaParolaChange={(ev) => { this.setState({ repetParola: ev.target.value }) }}
                        vParola={this.state.vParola}
                        toUpdate={this.state.toUpdate}
                        changeManager={this.changeManager}
                        stergeAngajat={() => { this.openDeleteUser(this.state.angajatInfo) }}
                        getData={() => { this.fromServer(this.state.angajatInfo) }}
                        openProgram={() => { this.setState({ isOpenProgram: true }) }}
                        dAccess={this.state.dAccess}
                        idDepartament={this.state.idDepartament}
                        changeidDepartament={this.changeidDepartament}
                        deleteDep={this.deleteDep}
                        noOrg={true}
                        changeAccessFinanciar={this.changeAccessFinanciar}
                    />
                }


                {this.state.isOpenProgram &&
                    <ProgramLucru
                        open={this.state.isOpenProgram}
                        dialogClose={() => { this.setState({ isOpenProgram: false }) }}
                        limba={this.dictionary}
                        angajat={this.state.angajatInfo}
                        changeProgram={this.changeProgram}
                        absent={this.absent}
                        salveazaProgram={this.saveProgram}
                        programSelectat={this.state.programSelectat}
                        changeProgramAll={this.changeProgramAll}
                        programCompanie={this.state.programCompanie}
                    />

                }

                {/* <div
                    onClick={() => { this.selectFile('fileproiect') }}
                    className='container'>
                    <h1 className='pm-title'>{this.dictionary.proiecte.segmentButtons.documente}</h1>
                    <div style={{ position: this.state.fullScreen ? '' : 'absolute', top: 0, right: 30, cursor: 'pointer' }}>
                        <i style={{ display: 'block', fontSize: 40, color: '#6f9ce2' }} className='material-icons'>cloud_upload</i>
                        <span className='pm-title'>{this.dictionary.proiecte.informatiiProiect.upload}</span>

                        <input type='file' id={`fileproiect`}
                            style={{ display: 'none' }}
                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                            onChange={() => { this.uploadDoc(`fileproiect`, this.props.idproiect) }} />

                    </div>


                </div> */}

                {/* <Grid style={{ maxWidth: 500, margin: 'auto' }} container>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeProiect}
                                checked={this.state.proiecteCheck} />
                            Proiecte</h3>

                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeEtape}
                                checked={this.state.etapeCheck} />
                            Etape</h3>

                    </Grid>

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeTaskuri}
                                checked={this.state.taskuriCheck} />
                            Taskuri</h3>

                    </Grid>



                </Grid> */}

                {/* 
                <Divider className='pm-divider' />
                <DocumenteList
                    elemente={this.state.listFiltered}
                    dict={this.dictionary}
                    onlyColumns={{ nume: 'nume', data: 'cand_uploadat', doc_info: 'doc_info' }}
                    goToFile={this.goToFile}
                    deleteFile={this.deleteFile}
                />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.alertDate.document}
                    limba={this.dictionary}
                    yesFunction={this.deleteDoc} /> */}

            </div >
        );
    }
}